import "./form.css.ts.vanilla.mjs";
var t = "p273__form-fc5a_fc6e18938__15t8tlc0";
export {
  t as formStyle
};
//# sourceMappingURL=form.mjs.map
